import { JetView } from 'webix-jet';

/**
 * Class representing the detailsPerfilOpcionesView.
 * @extends JetView
 */
export default class detailsPerfilOpcionesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            view: 'toolbar',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to the toolbar
                    elements: [
                        { view: 'label', label: _('Detalles'), width: 150 }, // Label for the toolbar
                    ],
                },
            ],
        };
        return {
            width: screen !== 'small' ? 500 : 230, // Set width based on screen size
            height: screen !== 'small' ? 300 : 230, // Set height based on screen size
            type: 'wide', // Type of the view
            cols: [left], // Columns layout
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
        });
    }
}

// FILE DOCUMENTED
